module.exports = __webpack_public_path__ + "static/img/pic_news2.3a4acc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/news/pic_news2.jpg
// module id = bXyc
// module chunks = 0